import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Goals() {
  return (
    <section className="goals-serve-easy case-about-sec case-about-right case-about-overlay">
      <Container>
        <Row className="align-items-center justify-content-between">
          
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-4">
            <div class="content text_white">
              <h2>
              Client’s Goal <br className="d-md-block d-none"/>with the POS App
              </h2>
              <p>The client required a high-performance POS app capable of managing diverse operations within cafés, restaurants, and hotels. The app needed to support seamless compatibility with various devices, offer an intuitive interface for ease of use, and maintain high-speed performance under heavy loads.</p>
              <p>Essential features included a secure, fast, and efficient payment gateway, real-time inventory tracking, and a kitchen display system that could streamline order management and communication between the front and back of house.</p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={6}
            className=""
          >
            <div className="image text-md-end text-center">
              <StaticImage
                src="../../../images/case-studies/serve-easy/goal.webp"
                alt="The Challenge"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={852}
              />
            </div>
          </Col>
          
        </Row>
      </Container>
    </section>
  );
}

export default Goals;
